import { resolveFormCountryCode } from "../countries/countryUtils";
import type { AuthorPartyRole, Commodity, ComplianceCaseCreate } from "./types";

const AUTHOR_PARTY_ROLES: AuthorPartyRole[] = [
  "importer_operator",
  "trader_exporter",
  "processor_buyer",
  "supplier_producer",
  "compliance_broker",
];

function trimString(value: unknown): string {
  return String(value ?? "").trim();
}

function countryCode(value: unknown): string {
  return resolveFormCountryCode(value);
}

function optionalString(value: unknown): string | undefined {
  const s = trimString(value);
  return s === "" ? undefined : s;
}

/** Build API payload from StepsForm values (alpha-2 countries, known fields only). */
export function buildComplianceCaseCreatePayload(
  values: Record<string, unknown>
): ComplianceCaseCreate {
  const role = trimString(values.author_party_role) as AuthorPartyRole;
  if (!AUTHOR_PARTY_ROLES.includes(role)) {
    throw new Error("author_party_role is required");
  }
  const payload: ComplianceCaseCreate = {
    commodity: values.commodity as Commodity,
    supplier_name: trimString(values.supplier_name),
    supplier_country: countryCode(values.supplier_country),
    buyer_name: trimString(values.buyer_name),
    buyer_country: countryCode(values.buyer_country),
    destination_country: countryCode(values.destination_country),
    author_party_role: role,
  };
  const supplierContact = optionalString(values.supplier_contact);
  if (supplierContact) payload.supplier_contact = supplierContact;
  const contractRef = optionalString(values.contract_reference);
  if (contractRef) payload.contract_reference = contractRef;
  const shipmentUnit = optionalString(values.shipment_unit);
  if (shipmentUnit) payload.shipment_unit = shipmentUnit;
  const authorDetail = optionalString(values.author_role_detail);
  if (authorDetail) payload.author_role_detail = authorDetail;
  const clientOrg = optionalString(values.client_org_name);
  if (clientOrg) payload.client_org_name = clientOrg;
  if (values.shipment_volume != null && values.shipment_volume !== "") {
    payload.shipment_volume = Number(values.shipment_volume);
  }
  return payload;
}
